import { useState, useEffect } from "react";

const useScrollPosition = (bottomThreshold = 0, topThreshold = 0) => {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;

            const scrollHeight =
                document.documentElement.scrollHeight ||
                document.body.scrollHeight;

            const clientHeight =
                document.documentElement.clientHeight || window.innerHeight;

            const atTop = scrollTop <= topThreshold;
            const atBottom =
                scrollTop + clientHeight >= scrollHeight - bottomThreshold;

            if (atTop) {
                setPosition("top");
            } else if (atBottom) {
                setPosition("bottom");
            } else {
                setPosition(null);
            }
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [bottomThreshold, topThreshold]);

    return { position };
};

export default useScrollPosition;
